var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReceiptYellow = function SvgReceiptYellow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "receipt--yellow_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".receipt--yellow_svg__st1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M56.1 65.4 53.6 63l-3.1 2.9c-.2.2-.4.2-.6 0L46.8 63l-3.1 2.9c-.2.2-.4.2-.6 0L40 63l-3.1 2.9c-.2.2-.4.2-.6 0L33.2 63l-3.1 2.9c-.2.2-.4.2-.6 0L26.4 63l-2.6 2.5c-.3.3-.7.1-.7-.3v-50c0-.4.5-.6.7-.3l2.6 2.5 3.1-2.9c.2-.2.4-.2.6 0l3.1 2.9 3.1-2.9c.2-.2.4-.2.6 0l3.1 2.9 3.1-2.9c.2-.2.4-.2.6 0l3.1 2.9 3.1-2.9c.2-.2.4-.2.6 0l3.1 2.9 2.6-2.5c.3-.3.7-.1.7.3v50c0 .3-.6.5-.8.2z",
    style: {
      fill: "#fed607"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6 44H31.2v-1.6h18.4V44zM49.6 52H31.2v-1.6h18.4V52z",
    className: "receipt--yellow_svg__st1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.8 28.8H32V36h16.8v-7.2z",
    style: {
      fill: "#0b1b34"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2 28.8c0-.4.4-.8.8-.8h16.8c.4 0 .8.4.8.8V36c0 .4-.4.8-.8.8H32c-.4 0-.8-.4-.8-.8v-7.2zm1.6.8v5.6H48v-5.6H32.8z",
    className: "receipt--yellow_svg__st1"
  })));
};
export default SvgReceiptYellow;